/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as SurveyAnswerPlantQuantityStockTypeService} from "../../../Services/SurveyAnswerPlantQuantityStockTypeService";
import {ServiceDrivenFieldViewer} from "../../../Models/Core/FieldViewers/ServiceDrivenFieldViewer";

export const SurveyAnswerPlantQuantityStockTypeFieldViewer = ServiceDrivenFieldViewer(SurveyAnswerPlantQuantityStockTypeService);
